// for sync button
export const setSyncButtonClass = (status: string): string => {
    let result = '';
    if (status == 'InProgress') result = 'in-progress';
    if (status == 'Queued') result = 'queued';
    if (status == 'Failed') result = 'failed';
    return result;
};
